import type { ChanelActionType, OrderBookRepoWs, SubscribeToChannelResult } from "@trading/infrastructure";
import type { OrderBookModel } from "../models/order-book.model";

export default class OrderBookService {
  constructor(private repo: OrderBookRepoWs) {}

  async subscribeToOrderBookUpdate(
    instrument: string,
    actionName: ChanelActionType,
    cb: (order: OrderBookModel) => void
  ): Promise<undefined | SubscribeToChannelResult> {
    return await this.repo?.subscribeToChannelsActionByInstrument(instrument, actionName, cb)
  }
}